// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1441":"IconCards-Chunk","4711":"ColourCardCarousel-Chunk","5298":"ProductCarousel-Chunk","6413":"HotspotCards-Chunk","7131":"ContentCards-Chunk","8958":"WishlistListing-Chunk"}[chunkId] + ".min.css";
};